import { ScreenScales } from './../config/GameBoard';
import { gte } from 'lodash';
export const getScreenScale = (width: number): number => {

    if (gte(width, 700)) {
        return ScreenScales.SevenHundreds;
    }

    if (gte(width, 600)) {
        return ScreenScales.SixHundreds;
    }

    if (gte(width, 500)) {
        return ScreenScales.FiveHundreds;
    }

    if (gte(width, 400)) {
        return ScreenScales.FourHundreds;
    }

    if (gte(width, 300)) {
        return ScreenScales.ThreeHundreds;
    }

    if (gte(width, 200)) {
        return ScreenScales.TwoHundreds;
    }

    return 0;
}
